import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
// import { getToken } from '@/utils/auth'
import router from "@/router";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000*60 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    

    const token = localStorage.getItem('token');
    if (token) {
      config.headers['token'] = token;
    }

    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)



// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response

    // if the custom code is not 20000, it is judged as an error.
    if (res.data.errorCode&&res.data.errorCode !== '0') {
      Message({
        message: res.data.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.data.errorCode === "100401" || res.data.errorCode === 50012 || res.data.errorCode === 50014) {
        
        console.log("------检测到未登录，准备跳转登录页")
        router.push({ path: "/login" })
      }
      return Promise.reject(new Error(res.data.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js